import { bindMethod } from 'helpers/bind';
import Component from 'navigation/component/Component';
export default class Field extends Component {
    initialized() {
        super.initialized();
    }
    bindEvents(add) {
        const method = bindMethod(add);
        this.refs.fieldInput?.[method]('focus', this.handleFocus);
        this.refs.fieldInput?.[method]('blur', this.handleBlur);
        this.el?.[method]('click', this.handleClick);
    }
    handleClick = () => {
        this.refs.fieldInput.focus();
    };
    handleFocus = () => {
        this.el.classList.add('field__is--focused');
    };
    handleBlur = () => {
        this.el.classList.remove('field__is--focused');
    };
}
